import {Component, OnInit} from '@angular/core';
import {StorageKeysEnum} from '../../lib/storage/storage-keys.enum';
import {FormBuilder} from "@angular/forms";
import {ThanksFeedbackService} from '../../lib/services/thanks-feedback/thanks-feedback.service';
import {FeedbackMessageTypeEnum} from "../../lib/services/thanks-feedback/feedback-message-type.enum";
import { FeedbackService } from '../../lib/services/feedback/feedback.service';

@Component({
  selector: 'app-feedback-form',
  templateUrl: './feedback-form.component.html',
  styleUrls: ['./feedback-form.component.scss']
})
export class FeedbackFormComponent implements OnInit {
  chargedForm: boolean = true;
  isValidToken :boolean = true;
  feedbackForm: any;
  feedbackToken:any;
  experienceValue:number = 0;
  desingValue:number = 0;
  feedbackValue:String = "";
  sExperienceValue:String = "";
  sDesingValue: String = "";
  fedbackJson: any;
  constructor(private formBuilder: FormBuilder,
              private tanksFeedbackService: ThanksFeedbackService,
              private feedbackService : FeedbackService) { }

  ngOnInit(): void {
    this.feedbackToken = sessionStorage.getItem(StorageKeysEnum.TOKEN_FEEDBACK);
    this.buildForm();
  }

  buildForm() {
    this.feedbackForm = this.formBuilder.group({
      experience: ["0"],
      design: ["0"],
      feedbackInput: [""],
    });
  }

  setFeedback(){
    switch(Number(this.experienceValue)){
      case 0:
        this.sExperienceValue = "Mala";
        break;

      case 50:
        this.sExperienceValue = "Regular";
        break;

      case 100:
        this.sExperienceValue = "Muy buena";
        break;
    }

    switch(Number(this.desingValue)){
      case 0:
        this.sDesingValue = "Mala";
        break;

      case 50:
        this.sDesingValue = "Regular";
        break;

      case 100:
        this.sDesingValue = "Muy buena";
        break;
    }
    this.feedbackValue = this.feedbackForm?.getRawValue()?.feedbackInput;
    this.fedbackJson = {
      experience : this.sExperienceValue,
      design : this.sDesingValue,
      feedback : this.feedbackValue
    }
    this.feedbackService.sendFeedback(this.feedbackToken,this.fedbackJson).subscribe({
      next : value => {
        if(value.code == 1){
          this.tanksFeedbackService.openFeedbackThanksModal(FeedbackMessageTypeEnum.SUCCESS);
        }else{
          this.tanksFeedbackService.openFeedbackThanksModal(FeedbackMessageTypeEnum.ERROR);
        }
      }
    });
    sessionStorage.removeItem(StorageKeysEnum.TOKEN_FEEDBACK);
  }

  setValueExperience(e){
    this.experienceValue = e.target.value;
  }
  setValueDesing(e){
    this.desingValue = e.target.value;
  }
}
